'use strict';

module.exports.isMac = function isMac() {
  return (/mac/i).test(navigator.platform);
};


// WEBPACK FOOTER //
// ./~/diagram-js/lib/util/Platform.js